module.exports = __webpack_public_path__ + "img/banner_Certification.bf47694f.jpg";